module.exports = __webpack_public_path__ + "img/Vector.6f4f5d28.svg";